import React, { useState } from "react";
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle,
} from "@mui/material";
import { Add, Save } from "@mui/icons-material";
import SelectWithServerData from "components/Select/SelectWithServerData";
import EndPoints from "utils/services/EndPoints";
import Api from "utils/services/Api";
import { getCodigoIfip } from "utils/Common";
import { useSnackbar } from "notistack";

const CreateAccountModal = ({
  codigoSocio,
  onAccountAssigned,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tipoCuenta, setTipoCuenta] = useState(0);
  const { enqueueSnackbar } = useSnackbar();

  const onClose = () => {
    setIsOpen(false)
  }

  const save = async () => {
    try {
      if (tipoCuenta !== 0) {
        setLoading(true)
        await Api(
          `${EndPoints.asignaCuentas}/${codigoSocio}/${getCodigoIfip()}/${tipoCuenta}`,
          "POST",
          null
        )
        enqueueSnackbar("Cuenta asignada correctamente", { variant: "success" })
        onClose()
        onAccountAssigned()
      }
    } catch (error) {
      enqueueSnackbar(error.message, { variant: "error" })
    } finally {
      setLoading(false)
    }
  };

  return (
    <>
      <Button
        type="primary"
        variant="contained"
        onClick={() => setIsOpen(true)}
        startIcon={<Add />}
      >
        Asigna Cuenta
      </Button>
      <Dialog
        open={isOpen}
        onClose={onClose}
        fullWidth
      >
        <DialogTitle variant="h3">
          Asignar cuenta
        </DialogTitle>
        <DialogContent>
          <SelectWithServerData
            id="tipoCuenta"
            label="Tipo Producto"
            endpoint={EndPoints.listTipoProducto}
            value={tipoCuenta}
            onChange={(_, { props: { value }, ...rest }) => {
              setTipoCuenta(value)
            }}
            sx={{
              marginTop: 3
            }}
          />
        </DialogContent>
        <DialogActions sx={{
          justifyContent: "space-between"
        }}>
          <Button
            onClick={onClose}
            autoFocus
            disabled={loading}
          >
            Cerrar
          </Button>
          <Button
            type="primary"
            variant="contained"
            startIcon={<Save />}
            onClick={save}
            disabled={loading}
          >
            Agregar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default CreateAccountModal